import { Epic, ofType } from "redux-observable";
import { PayrollFileActions } from "../actions";
import { RootState } from "../../reducers";
import { Observable } from "rxjs";
import {
    DOWNLOAD_PAYROLL_TEMPLATE_FILE,
    GET_PAYROLL_FILE_PROCESS,
    UPLOAD_PAYROLL_FILE,
} from "../constants";
import { switchMap } from "rxjs/operators";
import { PayrollFileRepository } from "../../../repositories/payroll-file.repository";
import { GetPayrollFileProcess, PayrollFileUpload } from "../actions/default";

export const payrollFileDownloadTemplateFileEpic: Epic<
    PayrollFileActions,
    PayrollFileActions,
    RootState
> = (action$: Observable<PayrollFileActions>) =>
    action$.pipe(
        ofType(DOWNLOAD_PAYROLL_TEMPLATE_FILE),
        switchMap(() => PayrollFileRepository.downloadPayrollFileTemplate())
    );

export const payrollFileUploadEpic: Epic<
    PayrollFileActions,
    PayrollFileActions,
    RootState
> = (action$: Observable<PayrollFileActions>) =>
    action$.pipe(
        ofType(UPLOAD_PAYROLL_FILE),
        switchMap((action) => {
            return PayrollFileRepository.uploadPayrollFile(
                action as PayrollFileUpload
            );
        })
    );

export const getPayrollFileProcessEpic: Epic<
    PayrollFileActions,
    PayrollFileActions,
    RootState
> = (action$: Observable<PayrollFileActions>) =>
    action$.pipe(
        ofType(GET_PAYROLL_FILE_PROCESS),
        switchMap((action) =>
            PayrollFileRepository.getPayrollFileProcess(
                action as GetPayrollFileProcess
            )
        )
    );
